// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.room-container {
  display: flex;
  flex-direction: row;
  margin-top: 2.333rem;
}
.room-container .col {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.room-container .col .content-col-1 {
  margin-left: 2.333rem;
  margin-right: 2.333rem;
}
.room-container .col .content-col-1 .title-page {
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.375rem;
  color: var(--color-primary-blue);
  margin-bottom: 2.583rem;
}
.room-container .col .content-col-1 .gameOptionsForm ion-select > label,
.room-container .col .content-col-1 .gameOptionsForm ion-select,
.room-container .col .content-col-1 .gameOptionsForm ion-item {
  min-height: 1.917rem;
  --min-height: 1.917rem;
  height: 1.917rem;
  color: var(--color-primary-blue);
  font-weight: 600;
  font-size: 1rem;
}
.room-container .col .content-col-1 .gameOptionsForm .label-style {
  font-size: 1rem;
  line-height: 1rem;
  color: var(--color-primary-blue);
}
.room-container .col .content-col-1 .gameOptionsForm .select-box {
  border-radius: 0.667rem;
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, #d1d5db 0 0 0 1px inset;
  margin-bottom: 1rem;
  margin-top: 0.3rem;
}
.room-container .col .content-col-1 .gameOptionsForm .select-box.item-interactive-disabled {
  --background: #D3D3D3;
}
.room-container .col .content-col-1 .avatar-div {
  margin-bottom: 1.375rem;
  padding-left: 1rem;
}
.room-container .col .content-col-1 .customise-btn {
  font-size: 1rem;
  min-width: 6.333rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
}
.room-container .leave {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
}
.room-container .leave .start-btn {
  height: 2.667rem;
  min-height: 2.667rem;
  --min-height: 2.667rem;
  min-width: 8.25rem;
  font-size: 1rem;
  line-height: 1.375rem;
}
.room-container .game {
  width: 24.333rem;
  min-height: 21.667rem;
  display: flex;
  flex-direction: column;
  position: relative;
}
.room-container .game .header {
  display: flex;
  background: white;
  justify-content: space-between;
  padding: 1.25rem 1.25rem 1.042rem 1.25rem;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--color-primary-blue);
  font-weight: bold;
  border-radius: 0.667rem 0.667rem 0 0;
  align-items: center;
  height: 3.667rem;
}
.room-container .game .header .share-button {
  font-size: 0.75rem;
  --color: var(--color-primary-blue);
  --border-radius: 0.833rem;
  --background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  --padding-top: 0.333rem;
  --padding-bottom: 0.333rem;
  --padding-left: 1rem;
  --padding-right: 1rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
  min-width: 9.333rem;
  max-width: 13.333rem;
}
.room-container .game .body {
  background: rgba(207, 231, 237, 0.5);
  padding-bottom: 2.708rem;
  border-radius: 0 0 0.667rem 0.667rem;
}
.room-container .game .body .player {
  display: flex;
  padding-left: 2.208rem;
  padding-right: 1rem;
  padding-top: 1rem;
}
.room-container .game .body .player img {
  width: 2rem;
  height: auto;
  padding-left: 0.333rem;
  padding-right: 0.333rem;
}
.room-container .game .body .player.current {
  padding-top: 1.458rem;
}
.room-container .game .body .player.current img {
  padding: 0rem;
}
.room-container .game .body .player .details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 0.792rem;
  align-self: center;
}
.room-container .game .body .player .details .host {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1rem;
  height: 1rem;
  margin-bottom: 0.167rem;
  color: var(--color-primary-blue);
}
.room-container .game .body .player .details .name {
  display: flex;
  flex-grow: 1;
  align-items: center;
}
.room-container .game .body .player .details .name.edit {
  background: white;
  border-radius: 0.833rem;
  height: 1.667rem;
}
.room-container .game .body .player .details .name .text {
  color: #35647E;
  font-size: 1rem;
  line-height: 1rem;
  flex-grow: 1;
}
.room-container .game .body .player .details .name .text.clickable {
  cursor: pointer;
}
.room-container .game .body .player .details .name .button {
  --border-radius: 0.833rem;
  --color: var(--color-primary-blue);
  --border-color: var(--color-primary-blue);
  height: 1.667rem;
  width: 7.417rem;
  font-size: 0.75rem;
}
.room-container .game .start-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  height: 2.75rem;
  min-height: 2.75rem;
  --min-height: 2.75rem;
  width: 14rem;
  font-size: 1.167rem;
  font-weight: 600;
  letter-spacing: 0;
}

.waiting-host {
  font-size: 1rem;
  margin-top: 2rem;
  color: var(--color-primary-blue);
  line-height: 1.375rem;
}

.kick-out {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.kick-out .kick-out-modal {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 1rem;
  border-radius: 0.833rem;
  text-align: center;
}
.kick-out .kick-out-modal .text {
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--color-primary-blue);
}
.kick-out .kick-out-modal .kick-button {
  --border-radius: 0.833rem;
  --color: white;
  --border-color: var(--color-red_line-red);
  --background: var(--color-red_line-red);
  height: 1.667rem;
  min-width: 7.417rem;
  font-size: 1rem;
  margin-top: 1rem;
}
.kick-out .overlay {
  width: 100%;
  height: 100%;
  background: rgba(207, 231, 237, 0.5);
}

.small-kick-button {
  --border-radius: 0.833rem;
  --color: white !important;
  --border-color: var(--color-red_line-red);
  --background: var(--color-red_line-red);
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
  width: auto !important;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/multiplayer-room/multiplayer-room.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AACI;EACE,qBAAA;EACA,sBAAA;AACN;AACM;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gCAAA;EACA,uBAAA;AACR;AAGQ;;;EAGE,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;AADV;AAKQ;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAHV;AAMQ;EACE,uBAAA;EACA,sEAAA;EACA,mBAAA;EACA,kBAAA;AAJV;AAMU;EACE,qBAAA;AAJZ;AASM;EACE,uBAAA;EACA,kBAAA;AAPR;AAUM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AARR;AAaE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;AAXJ;AAaI;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAXN;AAeE;EACE,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAbJ;AAeI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;EACA,gCAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AAbN;AAeM;EACE,kBAAA;EACA,kCAAA;EACA,yBAAA;EACA,2HAAA;EACA,uBAAA;EACA,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAbR;AAiBI;EACE,oCAAA;EACA,wBAAA;EACA,oCAAA;AAfN;AAiBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAfR;AAiBQ;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AAfV;AAkBQ;EACE,qBAAA;AAhBV;AAkBU;EACE,aAAA;AAhBZ;AAoBQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;AAlBZ;AAqBU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAnBZ;AAqBY;EACE,iBAAA;EACA,uBAAA;EACA,gBAAA;AAnBd;AAsBY;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AApBd;AAsBc;EACE,eAAA;AApBhB;AAwBY;EACE,yBAAA;EACA,kCAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAtBd;AA6BI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA3BN;;AAgCA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,qBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA7BF;AA+BE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AA7BJ;AA+BI;EACE,eAAA;EACA,qBAAA;EACA,gCAAA;AA7BN;AAgCI;EACE,yBAAA;EACA,cAAA;EACA,yCAAA;EACA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA9BN;AAkCE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;AAhCJ;;AAoCA;EACE,yBAAA;EACA,yBAAA;EACA,yCAAA;EACA,uCAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAjCF","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.room-container {\n  display: flex;\n  flex-direction: row;\n  margin-top: 2.333rem;\n\n  .col {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    .content-col-1 {\n      margin-left: 2.333rem;\n      margin-right: 2.333rem;\n\n      .title-page {\n        font-size: 1rem;\n        font-weight: bold;\n        line-height: 1.375rem;\n        color: var(--color-primary-blue);\n        margin-bottom: 2.583rem;\n      }\n\n      .gameOptionsForm {\n        ion-select > label,\n        ion-select,\n        ion-item {\n          min-height: 1.917rem;\n          --min-height: 1.917rem;\n          height: 1.917rem;\n          color: var(--color-primary-blue);\n          font-weight: 600;\n          font-size: 1rem;\n        }\n\n\n        .label-style {\n          font-size: 1rem;\n          line-height: 1rem;\n          color: var(--color-primary-blue);\n        }\n\n        .select-box {\n          border-radius: 0.667rem;\n          box-shadow: rgb(0 0 0 / 16%) 2px 3px 0 1px, #d1d5db 0 0 0 1px inset;\n          margin-bottom: 1rem;\n          margin-top: 0.3rem;\n\n          &.item-interactive-disabled {\n            --background: #D3D3D3;\n          }\n        }\n      }\n\n      .avatar-div {\n        margin-bottom: 1.375rem;\n        padding-left: 1rem;\n      }\n\n      .customise-btn {\n        font-size: 1rem;\n        min-width: 6.333rem;\n        height: 1.667rem;\n        min-height: 1.667rem;\n        --min-height: 1.667rem;\n      }\n    }\n  }\n\n  .leave {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: center;\n\n    .start-btn {\n      height: 2.667rem;\n      min-height: 2.667rem;\n      --min-height: 2.667rem;\n      min-width: 8.25rem;\n      font-size: 1rem;\n      line-height: 1.375rem;\n    }\n  }\n\n  .game {\n    width: 24.333rem;\n    min-height: 21.667rem;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    .header {\n      display: flex;\n      background: white;\n      justify-content: space-between;\n      padding: 1.25rem 1.25rem 1.042rem 1.25rem;\n      font-size: 1rem;\n      line-height: 1.375rem;\n      color: var(--color-primary-blue);\n      font-weight: bold;\n      border-radius: 0.667rem 0.667rem 0 0;\n      align-items: center;\n      height: 3.667rem;\n\n      .share-button {\n        font-size: 0.75rem;\n        --color: var(--color-primary-blue);\n        --border-radius: 0.833rem;\n        --background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n        --padding-top: 0.333rem;\n        --padding-bottom: 0.333rem;\n        --padding-left: 1rem;\n        --padding-right: 1rem;\n        height: 1.667rem;\n        min-height: 1.667rem;\n        --min-height: 1.667rem;\n        min-width: 9.333rem;\n        max-width: 13.333rem;\n      }\n    }\n\n    .body {\n      background: rgba(207, 231, 237, 0.5);\n      padding-bottom: 2.708rem;\n      border-radius: 0 0 0.667rem 0.667rem;\n\n      .player {\n        display: flex;\n        padding-left: 2.208rem;\n        padding-right: 1rem;\n        padding-top: 1rem;\n\n        img {\n          width: 2rem;\n          height: auto;\n          padding-left: 0.333rem;\n          padding-right: 0.333rem;\n        }\n\n        &.current {\n          padding-top: 1.458rem;\n\n          img {\n            padding: 0rem;\n          }\n        }\n\n        .details {\n          display: flex;\n          flex-direction: column;\n          flex-grow: 1;\n          padding-left: 0.792rem;\n          align-self: center;\n\n          .host {\n            font-size: 1rem;\n            font-weight: 600;\n            line-height: 1rem;\n            height: 1rem;\n            margin-bottom: 0.167rem;\n            color: var(--color-primary-blue);\n          }\n\n          .name {\n            display: flex;\n            flex-grow: 1;\n            align-items: center;\n\n            &.edit {\n              background: white;\n              border-radius: 0.833rem;\n              height: 1.667rem;\n            }\n\n            .text {\n              color: #35647E;\n              font-size: 1rem;\n              line-height: 1rem;\n              flex-grow: 1;\n\n              &.clickable {\n                cursor: pointer;\n              }\n            }\n\n            .button {\n              --border-radius: 0.833rem;\n              --color: var(--color-primary-blue);\n              --border-color: var(--color-primary-blue);\n              height: 1.667rem;\n              width: 7.417rem;\n              font-size: 0.75rem;\n            }\n          }\n        }\n      }\n    }\n\n    .start-btn {\n      position: absolute;\n      bottom: 0;\n      left: 50%;\n      transform: translate(-50%, 50%);\n      height: 2.75rem;\n      min-height: 2.75rem;\n      --min-height: 2.75rem;\n      width: 14rem;\n      font-size: 1.167rem;\n      font-weight: 600;\n      letter-spacing: 0;\n    }\n  }\n}\n\n.waiting-host {\n  font-size: 1rem;\n  margin-top: 2rem;\n  color: var(--color-primary-blue);\n  line-height: 1.375rem;\n}\n\n.kick-out {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n\n  .kick-out-modal {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 1rem;\n    border-radius: 0.833rem;\n    text-align: center;\n\n    .text {\n      font-size: 1rem;\n      line-height: 1.375rem;\n      color: var(--color-primary-blue);\n    }\n\n    .kick-button {\n      --border-radius: 0.833rem;\n      --color: white;\n      --border-color: var(--color-red_line-red);\n      --background: var(--color-red_line-red);\n      height: 1.667rem;\n      min-width: 7.417rem;\n      font-size: 1rem;\n      margin-top: 1rem;\n    }\n  }\n\n  .overlay {\n    width: 100%;\n    height: 100%;\n    background: rgba(207, 231, 237, 0.5);\n  }\n}\n\n.small-kick-button {\n  --border-radius: 0.833rem;\n  --color: white !important;\n  --border-color: var(--color-red_line-red);\n  --background: var(--color-red_line-red);\n  height: 1.667rem;\n  min-height: 1.667rem;\n  --min-height: 1.667rem;\n  width: auto !important;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
